import * as React from "react";

export const UndoSvg = (props) => (
  <svg
    width={18}
    height={14}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.20793 13.0001H12.0801C14.796 13.0001 17.0002 10.8702 17.0002 8.24577C17.0002 5.62139 14.796 3.49146 12.0801 3.49146H1.25586"
      stroke={props.stroke || "#292D32"}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5191 5.86842L1 3.43421L3.5191 1"
      stroke={props.stroke || "#292D32"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
